module.exports = __webpack_public_path__ + "static/media/Rectangle.42a4b24f.svg";